import { createUseStyles } from "react-jss";

const ViewPortfolioStyles = createUseStyles({
    breadCrumbs: {
        margin: '30px 30px 0 30px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        paddingBottom: '16px',
        borderBottom: '1px solid #e0e0e0'
    },
    gridLayout: {
        display: "grid",
        gap: '10px',
        padding: 18,
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    },
    pageInfo: {
        display: "flex",
        flexDirection: "column",
        marginRight: "1rem",
    },
    pageInfoBold: {
        fontWeight: "bold",
        '& h4': {
            fontSize: "18px"
        }
    },
    title: {
        margin: '0',
        color: '#333333',
        fontWeight: '600'
    },
    editButton: {
        minWidth: '80px'
    },
    content: {
        '& > div': {
            marginBottom: '16px'
        }
    },
    editSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    editField: {
        width: '100%',
        maxWidth: '400px'
    },
    editActions: {
        display: 'flex',
        gap: '12px',
        alignItems: 'center'
    },
    saveButton: {
        minWidth: '80px'
    },
    cancelButton: {
        minWidth: '80px'
    },
    hyperlink: {
        color: '#0073e6',
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
            color: '#005bb5',
            textDecoration: 'none'
        },
        overflow: 'hidden'
    },
    // Override DisplayValue styles for better spacing
    '& .MuiGrid-container': {
        '& .MuiGrid-item': {
            paddingBottom: '8px'
        }
    },
    // Ensure proper spacing for DisplayValue labels and values
    displayValueContainer: {
        '& p': {
            margin: '0',
            lineHeight: '1.5'
        },
        '& strong': {
            color: '#555555',
            fontWeight: '600'
        }
    },
    nestedTable: {
        padding: 16
    },
    // Responsive design
    '@media (max-width: 768px)': {
        container: {
            padding: '16px',
            margin: '16px 0'
        },
        header: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '12px'
        },
        editActions: {
            flexDirection: 'column',
            width: '100%',
            '& button': {
                width: '100%'
            }
        },
        editField: {
            maxWidth: '100%'
        }
    }
});

export default ViewPortfolioStyles;
